import { useEffect, useState } from 'react';
import { fetchMedia } from '../lib/api';

// Fetches media for a category from the API. If the API returns zero items,
// the caller can choose to fall back to mock data.
export function useMedia(category) {
  const [items, setItems] = useState(null); // null = loading
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchMedia(category)
      .then((rows) => { if (alive) setItems(rows); })
      .catch((err) => { if (alive) { setItems([]); setError(err); } });
    return () => { alive = false; };
  }, [category]);

  return { items, loading: items === null, error };
}
